// extracted by mini-css-extract-plugin
export var container = "_3e-0";
export var error = "_3e-9";
export var label = "_3e-5";
export var light = "_3e-6";
export var md = "_3e-3";
export var sm = "_3e-2";
export var thin = "_3e-8";
export var thinBold = "_3e-7";
export var vertical = "_3e-4";
export var xs = "_3e-1";